import { join } from "path";
import React from "react";
import { Link } from "react-navi";
import { formatDate } from "../utils/formats";
import styles from "./ArticleMeta.module.css";

function ArticleMeta({ blogRoot, meta, readingTime }) {
  let readingTimeElement;
  if (readingTime) {
    let minutes = Math.max(Math.round(readingTime.minutes), 1);
    readingTimeElement = (
      <span className={styles.readingTime}>{minutes} min read</span>
    );
  }

  return (
    <div className={styles.ArticleMeta}>
      <time dateTime={meta.date.toUTCString()}>{formatDate(meta.date)}</time>
      {readingTimeElement && (
        <>
          <span className={styles.separator} aria-hidden="true" />
          {readingTimeElement}
        </>
      )}
      {meta.tags && meta.tags.length > 0 && (
        <ul className={styles.tags}>
          {meta.tags.map((tag) => (
            <li key={tag}>
              <Link href={join(blogRoot, "tags", tag)}>{tag}</Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default ArticleMeta;
